import axios from 'axios';
import {backendHost} from '../../config';

export const putWithdrawalsStatus = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/withdrawals/status`, params);
};